import { render, staticRenderFns } from "./UserNotificationSettings.vue?vue&type=template&id=dfa122ea&"
import script from "./UserNotificationSettings.vue?vue&type=script&lang=ts&"
export * from "./UserNotificationSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports